import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'
import Home from '../views/Home.vue'

// импорт api
// import usersApi from '@/api/usersApi'

// роуты
import reports from './reports'
import contracts from './contracts'
import contractors from './contractors'
import pvh from './pvh'
import approve from './approve'
import unloading from './unloading'
import logistics from './logistics'
import edo from './edo'
import pto from './pto'
import standards from './standards'
import tasks from './tasks'
import users from './users'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/feed',
    name: 'Feed',
    component: () => import('../views/Feed.vue')
  },
  // плагин сотрудников
  ...users,
  // задачи
  ...tasks,
  // плагин отчетов
  ...reports,
  // плагин договоров
  ...contracts,
  // плагин контрагенты
  ...contractors,
  // плагин пвх
  ...pvh,
  // плагин листы согласования
  ...approve,
  // плагин выгрузок
  ...unloading,
  // плагин логистика
  ...logistics,
  // pages Edo
  ...edo,
  // pages PTO
  ...pto,
  // pages standards
  ...standards
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // получение данных пользователя при любом переходе
  // if (localStorage.currentUserId) {
  //   usersApi.getCurrentUser().then(response => {
  //     store.commit('GET_CURRENT_USER_DATA', response.data.data)
  //     store.commit('[roles] SET_RIGHTS', response.data.data.roles)
  //     store.dispatch('initialiseMenu')
  //   }).catch(() => {
  //     store.dispatch('logOut').then(() => {
  //       store.commit('GET_CURRENT_USER_DATA_FAILURE')
  //       store.commit('SHOW_LOGIN_ERROR_MESSAGE')
  //     })
  //   })
  // }
  // если мобильная версия, нужно закрывать меню после перехода
  const isMobile = store.getters.getMediaBreakpoint !== 'desktop'
  if (isMobile) {
    store.commit('CLOSE_MAIN_MENU_MOBILE')
  }
  next()
})

export default router
